module.exports = __webpack_public_path__ + "img/New PACI Flow - New User AR - 10.449083f0.png";